export function isCurrentDomain(url) {
  if (!url) return false;
  return new RegExp(`^http(s)?://${window.location.host}/`, 'i').test(url);
}

export function sanitiseURL(url, prepend = true) {
  if (!url) return null;

  let u = url;

  // Strip out @'s
  if (url.indexOf('@') !== -1) {
    u = url.replace('@', '');
  }

  // Skip the check if URL provided is relative and prepend current domain if needed
  if (u.indexOf('http') !== 0) {
    if (u.indexOf('/') !== 0) u = `/${u}`;
    if (prepend) u = window.location.href.replace(/\/launchpad(.*)/, '') + u;
    return u;
  }

  // Prevent XSS and restrict URLs to current domain
  if (isCurrentDomain(u)) {
    return u;
  }

  return null;
}

// fixProtocol changes the url's protocol
// from http to https, if it ends with
// "teamwork.com" - this is to make sure
// that secure cookies are set correctly
// during generic login (we redirect to
// HTTPS but cookie could be set as secure
// on the HTTP url)
export function fixProtocol(url) {
  const end = '.teamwork.com/';
  if (url.indexOf(end) !== url.length - end.length) return url;
  if (url.indexOf('https://') === 0) return url;
  return url.replace('http://', 'https://');
}

export function navigateExternalURL(url, isIframe) {
  if (!url) return;
  if (!isIframe) {
    window.location.href = url;
    return;
  }
  if (sessionStorage) sessionStorage.setItem('shouldCloseOpener', 'true');
  window.open(url, '_blank');
}

export function buildQueryString(data = {}) {
  const params = [];
  for (const k in data) { // eslint-disable-line
    if (data.hasOwnProperty(k)) { // eslint-disable-line
      params.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
    }
  }
  return params.join('&');
}



// WEBPACK FOOTER //
// ./src/utils/urlHelper.js